@if (isLoading) {
<div class="spinner-container">
    <mat-spinner [diameter]="50"></mat-spinner>
</div>
} @else if (orderItem) {

<div class="order-timeline-container">
    <div class="top-container">
        <div class="left-section">
            <div class="icon-container" (click)="goBack()">
                <mat-icon svgIcon="arrowleft" class="back-icon"></mat-icon>
            </div>

            <div class="title-container">
                <p class="title font-poppins">Order Items</p>
                <p class="subtitle">
                    <span class="status">{{ orderItem.itemStatus }}</span>
                    <span class="created-at">
                        <mat-icon [svgIcon]="'date'" class="date-icon"></mat-icon>
                        Ordered : {{ orderItem.createdAt | date: "MMM dd, yyyy" }}
                    </span>
                </p>
            </div>
        </div>

        <div class="right-section">
            <p class="orderid-label">Order ID</p>
            <p class="order-id font-poppins">#{{ orderId }}</p>
        </div>
    </div>

    <div class="bottom-container">
        <div class="left-section">
            <div class="item-section">
                <div class="image-container product-image-gradient1">
                    <img class="item-image" [src]="orderItem.product?.images?.imagesUrl?.[0]" />
                </div>

                <div class="item-details">
                    <p class="name-track-container">
                        <span class="product-name font-poppins" appEllipsis maxWidth="80%">{{
                            orderItem.product?.name
                        }}</span>
                    </p>

                    @if (!orderItem.product?.category?.includes(categories.BuyBlocks)) {
                    <p class="description">
                        <span>Color: MultiColor</span>
                        <span class="block">{{ orderItem.product?.modelQuantityJson?.totalBlock }} Blocks</span>
                    </p>
                    } @else {
                    <div
                        class="block-item-info-container"
                        *ngIf="orderItem.product?.category?.includes(categories.BuyBlocks)"
                    >
                        <div class="node-hole-plane-config">
                            <div *ngIf="getFacesByType(orderItem, 'Plane').length > 0" class="plane-config">
                                <span class="block-face-label">{{ "cart.shapeFacetype.plane" | translate }}: </span>
                                <span class="block-face-value">{{
                                    getFacesByType(orderItem, "Plane").join(", ")
                                }}</span>
                            </div>

                            <div *ngIf="getFacesByType(orderItem, 'Hole').length > 0" class="hole-config">
                                <span class="block-face-label">{{ "cart.shapeFacetype.hole" | translate }}: </span>
                                <span class="block-face-value">{{ getFacesByType(orderItem, "Hole").join(", ") }}</span>
                            </div>

                            <div *ngIf="getFacesByType(orderItem, 'Node').length > 0" class="node-config">
                                <span class="block-face-label">{{ "cart.shapeFacetype.node" | translate }}: </span>
                                <span class="block-face-value">{{ getFacesByType(orderItem, "Node").join(", ") }}</span>
                            </div>
                        </div>

                        <div class="color-config">
                            <div class="color-title-section">
                                <mat-icon [svgIcon]="'color'" class="color-icon"></mat-icon>
                                <p class="color-title">Custom Color configuration</p>
                            </div>

                            <div class="color-info">
                                <div *ngFor="let color of getFaceColors(orderItem.singleBlockInfoDirectBuy?.color)">
                                    <div class="color-item">
                                        <div class="color-name">
                                            <span
                                                class="color-box"
                                                [ngStyle]="{
                                                    'background-color': getColorValue(color.value)
                                                }"
                                            ></span>
                                            <span class="block-face-label">{{ color.key }} </span>
                                        </div>
                                        <div class="block-face-value">
                                            {{ color.value }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }

                    <div class="quantity-price-container">
                        <p class="quantity-container">
                            <span class="label">Qunatity</span>
                            <span class="value">{{ orderItem.quantity }}x</span>
                        </p>
                        <p class="price-container">
                            <span class="label">Price</span>
                            <span class="price-info font-poppins">
                                <span class="price">
                                    {{ orderItem.discountedPrice || orderItem.price | currency: "INR" }}
                                </span>
                            </span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="order-process-section">
                <p class="order-process-heading font-poppins">Order Process</p>

                <div class="timeline-section">
                    <app-order-timeline
                        *ngIf="
                            showTimeline &&
                            (orderItem.itemStatus === OrderStatus.Ordered ||
                                orderItem.itemStatus === OrderStatus.Packed ||
                                orderItem.itemStatus === OrderStatus.Dispatched ||
                                orderItem.itemStatus === OrderStatus.Delivered ||
                                orderItem.itemStatus === OrderStatus.Cancelled)
                        "
                        [statusHistory]="filteredOrderStatusHistory!"
                    ></app-order-timeline>

                    <app-order-timeline
                        *ngIf="
                            orderItem.itemStatus === OrderStatus.ReturnInitiated ||
                            orderItem.itemStatus === OrderStatus.Returned ||
                            orderItem.itemStatus === OrderStatus.PickupScheduled
                        "
                        [statusHistory]="filteredReturnOrderStatusHistory!"
                    ></app-order-timeline>

                    <app-order-timeline
                        *ngIf="
                            orderItem.itemStatus === OrderStatus.ExchangeInitiated ||
                            orderItem.itemStatus === OrderStatus.ExchangePacked ||
                            orderItem.itemStatus === OrderStatus.Exchanged ||
                            orderItem.itemStatus === OrderStatus.ExchangeDispatched
                        "
                        [statusHistory]="filteredExchangeOrderStatusHistory!"
                    ></app-order-timeline>
                </div>
            </div>

            <div class="shipping-section">
                <div class="section">
                    <span class="icon-container delivery-icon">
                        <mat-icon svgIcon="date"></mat-icon>
                    </span>

                    <span class="label">Est. Delivery</span>
                    <span class="delivery-value font-poppins">{{ deliveryDate | date: "MMM dd, yyyy" }}</span>
                </div>

                <div class="section">
                    <span class="icon-container shipping-icon">
                        <mat-icon svgIcon="freedelivery"></mat-icon>
                    </span>
                    <span class="label">Shipping</span>
                    <span class="shipping-value font-poppins">Express</span>
                </div>

                <div class="section">
                    <span class="icon-container payment-icon">
                        <mat-icon svgIcon="onlinepay"></mat-icon>
                    </span>

                    <span class="label">Payment</span>
                    <span class="payment-value font-poppins">{{ orderItem.order?.paymentStatus }}</span>
                </div>

                <div class="section">
                    <span class="icon-container rewards-icon">
                        <mat-icon svgIcon="fullstar"></mat-icon>
                    </span>
                    <span class="label">Rewards</span>
                    <span class="reward-value font-poppins">+50 Pts</span>
                </div>
            </div>

            <div class="courier-section">
                <div class="title-container">
                    <span class="icon-container">
                        <mat-icon svgIcon="delivery"></mat-icon>
                    </span>
                    <span class="title font-poppins">Courier Info</span>
                </div>

                <p class="courier-name-section">
                    <span class="label">Courier Name</span>
                    <span class="value courier-name font-poppins">{{ orderItem.order?.courierName }}</span>
                </p>

                <p class="awb-section">
                    <span class="label">AWB Number</span>
                    <span class="value awb-number font-poppins">{{ orderItem.order?.awbNumber }}</span>
                </p>

                <p class="weight-section">
                    <span class="label">Weight</span>
                    <span class="value weight font-poppins">2kg</span>
                </p>
            </div>
        </div>

        <div class="right-section">
            <div class="delivery-location">
                <p class="heading font-poppins">
                    <span class="icon-container">
                        <mat-icon svgIcon="location"></mat-icon>
                    </span>
                    Delivery Address
                </p>

                <p class="name font-poppins">
                    {{ orderItem.order?.orderAddress?.shippingAddress?.name }}
                </p>
                <p class="address">
                    {{ orderItem.order?.orderAddress?.shippingAddress?.address }}
                </p>
                <p class="state">
                    {{ orderItem.order?.orderAddress?.shippingAddress?.city }},
                    {{ orderItem.order?.orderAddress?.shippingAddress?.state }},
                    {{ orderItem.order?.orderAddress?.shippingAddress?.pincode }}
                </p>
                <p class="phone">
                    <mat-icon svgIcon="phone" class="phone-icon"></mat-icon>
                    {{ orderItem.order?.orderAddress?.shippingAddress?.mobileNumber }}
                </p>
            </div>

            <div class="order-summary">
                <p class="heading font-poppins">Order Summary</p>

                <p class="section">
                    <span class="label">Subtotal</span>
                    <span class="value subtotal">{{ orderItem.order?.currentSubTotal | currency: "INR" }}</span>
                </p>

                <p class="section">
                    <span class="label">Discount</span>
                    <span class="value discount">-{{ orderItem.order?.currentCouponDiscount | currency: "INR" }}</span>
                </p>

                <p class="section">
                    <span class="label">Delivery Charges</span>
                    <span class="value delivery">FREE</span>
                </p>

                @if (orderItem.order?.originalCoinsUsed) {
                <p class="section">
                    <span class="label">Coins Used</span>
                    <span class="value coin">{{ orderItem.order?.originalCoinsUsed | currency: "INR" }}</span>
                </p>
                }

                <div class="separator"></div>

                <p class="section">
                    <span class="label total-label">Total Amount</span>
                    <span class="value total">{{ orderItem.order?.currentTotal | currency: "INR" }}</span>
                </p>
            </div>

            <div class="need-help-container">
                <p class="title-container">
                    <span class="icon-container">
                        <mat-icon>support_agent</mat-icon>
                    </span>
                    <span class="title font-poppins">Need Help?</span>
                </p>

                <button mat-flat-button class="btn btn-white">
                    <mat-icon>download</mat-icon>
                    Download Invoice
                </button>

                <button mat-flat-button class="btn btn-white">
                    <mat-icon>support_agent</mat-icon>
                    Contact Support
                </button>

                <!-- <button mat-flat-button class="btn btn-white" (click)="navigateItemList('return')">
                        <mat-icon>keyboard_return</mat-icon>
                        Return
                    </button>

                    <button mat-flat-button class="btn btn-white" (click)="navigateItemList('exchange')">
                        <mat-icon>swap_horiz</mat-icon>
                        Exchange
                    </button> -->
            </div>
        </div>
    </div>
</div>

} @else {
<div class="no-order-container">
    <app-no-order-item></app-no-order-item>
</div>
}
